import { ILocationModule } from '@store/tour/types';

const LOCATION_MODULE = {
  APPILY_AUTH_IFRAME: 'appily_authentication_iframe',
  APPILY: 'appily',
  LABELS: 'labels',
  SIDEKICK_AI: 'SIDE_KICK_AI',
};

/**
 * Check if a location module is enabled for the current platform
 * @param modules - Array of location modules
 * @param moduleId - The module ID to check for
 * @param platform - Current platform (web, vhost, facebook, thirdparty, mobile, etc.)
 * @returns True if module exists and is enabled for the platform, false otherwise
 */
export const isModuleEnabledForPlatform = (
  modules: ILocationModule[] = [],
  moduleId: string,
  platform: string | null = null
): boolean => {
  const module = modules.find(m => m.moduleid === moduleId);
  if (!module) {
    return false;
  }

  // If no platform specified, module cannot be verified as enabled
  if (!platform) {
    return false;
  }

  // Check if the module is enabled for the current platform
  return Number(module[platform]) === 1;
};

export default LOCATION_MODULE;
try {
    // @ts-ignore
    isModuleEnabledForPlatform.displayName = "isModuleEnabledForPlatform";
    // @ts-ignore
    isModuleEnabledForPlatform.__docgenInfo = { "description": "Check if a location module is enabled for the current platform", "displayName": "isModuleEnabledForPlatform", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/constants/locationModuleConstants.ts#isModuleEnabledForPlatform"] = { docgenInfo: isModuleEnabledForPlatform.__docgenInfo, name: "isModuleEnabledForPlatform", path: "src/constants/locationModuleConstants.ts#isModuleEnabledForPlatform" };
}
catch (__react_docgen_typescript_loader_error) { }